module.exports = __webpack_public_path__ + "pdf-white.png?b841d60b89e2daaae720d132c216fa76";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pdf-white.png
// module id = 1053
// module chunks = 0